// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__26CCW","title":"BackImages_title__1gTIe","images":"BackImages_images__3XJKv"};